import { SvgIcon } from '@mui/material';

const CopyIcon = (props) => (
    <SvgIcon viewBox="0 0 12 14" {...props}>
        <path
            d="M10.1 1H4.03333C3.31647 1 2.73333 1.59809 2.73333 2.33333V2.77778H2.3C1.58314 2.77778 1 3.37587 1 4.11111V12.1111C1 12.8464 1.58314 13.4444 2.3 13.4444H8.36667C9.08353 13.4444 9.66667 12.8464 9.66667 12.1111V11.6667H10.1C10.8169 11.6667 11.4 11.0686 11.4 10.3333V2.33333C11.4 1.59809 10.8169 1 10.1 1ZM8.8 12.1111C8.8 12.3563 8.60576 12.5556 8.36667 12.5556H2.3C2.0609 12.5556 1.86667 12.3563 1.86667 12.1111V4.11111C1.86667 3.86589 2.0609 3.66667 2.3 3.66667H8.36667C8.60576 3.66667 8.8 3.86589 8.8 4.11111V12.1111ZM10.5333 10.3333C10.5333 10.5786 10.3391 10.7778 10.1 10.7778H9.66667V4.11111C9.66667 3.37587 9.08353 2.77778 8.36667 2.77778H3.6V2.33333C3.6 2.08811 3.79424 1.88889 4.03333 1.88889H10.1C10.3391 1.88889 10.5333 2.08811 10.5333 2.33333V10.3333Z"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="0.25"
        />
    </SvgIcon>
);

export default CopyIcon